import { action } from 'mobx';
import { API, APIPaginatedResponse, APIResponse } from '../types';
import {TrackSchema} from '../../../types/schema';

export class PlaylistAPIController extends API {
  @action
  addTrackToPlaylist = async (user: string, playlist: string, track: string) => {
    const url = `/user/${user}/playlists/${playlist}`;
    const body = JSON.stringify({ track_id: track });
    const resp = await this.request.post({ url, body });

    return await resp.json();
  };

  @action
  removeTrackFromPlaylist = async (user: string, playlist: string, track: string) => {
    const url = `/user/${user}/playlists/${playlist}`;
    const body = JSON.stringify({ track_id: track });
    const resp = await this.request.del({ url, body });

    return await resp.json();
  };

  @action
  getTracks = async (user: string, playlist: string, page: number = 1, perPage: number = 25): Promise<APIPaginatedResponse<Array<TrackSchema>>> => {
    const url = `/user/${user}/playlists/${playlist}?page=${page}&perPage=${perPage}`;
    const resp = await this.request.get({ url });
    const json = await resp.json();

    this.cache.addTracks(json.data);

    return json;
  }
}